import { api } from "../api";

/**
 * findAllGeofencesByCustomerIdAndDepartmentIdCrudResponse - Function that finds on database all geofences by department and status as crud response data
 * /geofences/{customerId}/{departmentId}/{status}  
 * method GET  
 * @async-function
 */
const findAllGeofencesByCustomerIdAndDepartmentIdCrudResponse = async (token: string, userId: number, customerId: number, departmentId: number, status: string, page: number, size: number, ignoreDepartments: boolean = false) => {
    const response = await api.get(
        `/geofences/${userId}/${customerId}/${departmentId}/${status}?page=${page}&size=${size}&ignoreDepartments=${ignoreDepartments}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default findAllGeofencesByCustomerIdAndDepartmentIdCrudResponse;